module.exports = __webpack_public_path__ + "images/questions/hikakaku_q_logo_612b2878b815d9a9bfaae4261354ff42.png";